export default __webpack_public_path__ + "static/media/profile-about-me.b70618ea.svg";